import { ParticleBehaviour } from '../ParticleBehaviour';
import ParticlePool from 'app/views/home/webgl/particles/fields/ParticlePool';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';

export class ParticleTrail extends ParticleBehaviour {
	private _lifetimeFrames: number;
	private _alpha: number;
	private _scale: number;
	private _scaleStep: number;
	private _alphaStep: number;

	public set alpha(v: number) {
		this._alpha = v;
		this._setAlphaStep();
	}

	public set scale(v: number) {
		this._scale = v;
		this._setScaleStep();
	}

	public randomiseLifetime(base: number, seed: number = 0): void {
		this._lifetimeFrames = Math.round(base + Math.random() * seed);
		this._setAlphaStep();
		this._setScaleStep();
	}

	public tick(): void {
		this._alpha -= this._alphaStep * (window as any).deltaTime;
		this._scaleStep -= this._scaleStep * (window as any).deltaTime;

		if (this._alpha <= 0) {
			this._alpha = 0;
			this.active = false;
			ParticlePool.free(this._particleProps.ref as HomeParticle);
		}

		this._animatedProps.alpha = this._animatedProps.targetAlpha = this._alpha;
		this._animatedProps.scale = this._animatedProps.targetScale = this._scale;
	}

	private _setAlphaStep(): void {
		this._alphaStep = this._alpha / this._lifetimeFrames;
	}

	private _setScaleStep(): void {
		this._scaleStep = this._scale / this._lifetimeFrames;
	}
}
